import React from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import {
  getCartItemObject,
  getPriceWithCurrency,
  getQuotePriceWithTaxes,
  getTotalPrice,
  toFixedPrice
} from "../../../../../misc/helpers";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";

const LookWizardContentFinalPrice = (props) => {

  const {wizardSelectedValues, fabricatorSettings, qtActiveCategory} = props;

  if (!fabricatorSettings.showPricing) {
    return null
  }

  const cartItemsToCount = (Object.keys(wizardSelectedValues)).reduce((total, step) => {
    const selectedValue = wizardSelectedValues[step];
    if (!selectedValue || !selectedValue.selectedFeature) {
      return total
    }
    const parentPositions = selectedValue.selectedFeature.getParent().layerPositions
    const quantity = parentPositions
      ? Object.keys(parentPositions).filter(pos => parentPositions[pos]).length
      : 1;
    return [...total, getCartItemObject(selectedValue.selectedFeature, quantity, qtActiveCategory)]
  }, []);
  console.log("cartItemsToCount", cartItemsToCount);

  const totalPrice = getTotalPrice(null, false, cartItemsToCount, true);
  const grandTotal = getQuotePriceWithTaxes(totalPrice);

  return (
    <div className="lw-content__other-price">
      {IS_PRODUCT_JOURNEY ? (
        <span className="lw-content__other-price-total">
          <FormattedMessage id="receipt.total.total"/>:
        </span>
      ) : null}
      {getPriceWithCurrency(fabricatorSettings, toFixedPrice(grandTotal), null, true)}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {wizardSelectedValues} = store.wizardState;
  const {settings} = store.fabricatorState;
  const {qtActiveCategory} = store.qtState;

  return {
    wizardSelectedValues,
    fabricatorSettings: settings,
    qtActiveCategory,
  };
};

export default connect(mapStateToProps)(LookWizardContentFinalPrice)
